import * as React from 'react';
import { BodyMediumRegular, Switch, XStack } from 'smoothie';

import {
    BankingExperience,
    useBankingExperience,
} from '../../common/providers/BankingExperienceProvider';
import useGetAllBankAccountDetails from '../hooks/useGetAllBankAccountDetails';
import useGetAllBankAccountDetailsLegacy from '../hooks/useGetAllBankAccountDetailsLegacy';

const BankingExperienceToggle = () => {
    const {
        enableBankingExperienceToggle,
        bankingExperience,
        setBankingExperience,
    } = useBankingExperience();

    const { refetchAccountDetails } = useGetAllBankAccountDetails(false);
    const { refetchAccountDetails: refetchAccountDetailsLegacy } =
        useGetAllBankAccountDetailsLegacy(false);

    const toggleBankingExperience = () => {
        const newValue =
            bankingExperience === BankingExperience.LEGACY
                ? BankingExperience.CASH_CARD_ACCT
                : BankingExperience.LEGACY;
        setBankingExperience(newValue);

        if (newValue === BankingExperience.CASH_CARD_ACCT) {
            void refetchAccountDetails();
        } else {
            void refetchAccountDetailsLegacy();
        }
    };

    // Only show toggle if user is able to access cash/card account experience
    return enableBankingExperienceToggle ? (
        <XStack
            alignItems="center"
            justifyContent="space-between"
            maxWidth={350}
            marginVertical={20}
        >
            <BodyMediumRegular>
                Enable cash/card banking experience
            </BodyMediumRegular>
            <Switch
                isChecked={
                    bankingExperience === BankingExperience.CASH_CARD_ACCT
                }
                onCheckedChange={toggleBankingExperience}
            />
        </XStack>
    ) : (
        <></>
    );
};

export default BankingExperienceToggle;
